// import { Meta } from "@/types";
import { Meta } from "@_types/shared";

export const NO_META: Meta = {
  page: 0,
  pages: 0,
  pageSize: 0,
  total: 0,
};
